import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './badgeLarge.module.css';

import badgeYuyan from "../../../img/badge_yuyan.png";

import badgeTiyu from "../../../img/badge_tiyu.png";
import badgeYishu from "../../../img/badge_yishu.png";
import badgeShuxue from "../../../img/badge_shuxue.png";
import badgeLaodong from "../../../img/badge_laodong.png";
import badgePinde from "../../../img/badge_pinde.png";
import defaultImg from '../../../img/bee.svg';

class BadgeSmall extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, []);

        this.state = {
            reasonList: props.jichuZhangList
        };

    }

    componentDidMount() {

    }

    render() {
        return (
            <div className={styles.root} id='test'>

                <div>
                    {/*<div className={styles["title-badge"]}>*/}
                        {/*<div className={styles["text-green"]}>{sessionStorage.getItem('studentname')}同学在这个学期通过自己的努力获得了</div>*/}
                        {/*<div className={styles["text-red"]}>{this.props.hzsum}</div>*/}
                        {/*<div className={styles["text-green"]}>枚徽章</div>*/}
                    {/*</div>*/}

                    <div>
                        <div className={styles["text-red2"]}>恭喜你！</div>
                        <div className={styles["text-red2"]}>在这个学期通过自己的努力</div>

                        <div className={styles.info}>
                            <div className={styles["text-red3"]}>获得了</div>
                            <div className={styles["text-red"]}>{this.props.hzsum}</div>
                            <div className={styles["text-red3"]}>枚徽章</div>
                        </div>
                    </div>

                    <div className={styles["div-badge"]}>
                        <div className={styles["div-center-left5"]}>
                            <img className={this.props.jihao.includes(86)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(85)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(84)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(83)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(82)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(81)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />


                        </div>
                        <div className={styles["div-center-left4"]}>
                            <img className={this.props.jihao.includes(87)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(57)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(56)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(55)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(54)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(53)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(80)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />

                        </div>
                        <div className={styles["div-center-left3"]}>
                            <img className={this.props.jihao.includes(88)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(58)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(34)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(33)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(32)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(31)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(52)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                            <img className={this.props.jihao.includes(79)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />

                        </div>
                        <div className={styles["div-center-left2"]}>
                            <img className={this.props.jihao.includes(89)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(59)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(35)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(17)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(16)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />
                            <img className={this.props.jihao.includes(15)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />

                            <img className={this.props.jihao.includes(30)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                            <img className={this.props.jihao.includes(51)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                            <img className={this.props.jihao.includes(78)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />

                        </div>
                        <div className={styles["div-center-left1"]}>
                            <img className={this.props.jihao.includes(90)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(60)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(36)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(18)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(6)? styles["img-badge"] :styles["img-badge2"]} src={badgeYuyan} />
                            <img className={this.props.jihao.includes(5)? styles["img-badge"] :styles["img-badge2"]} src={badgeTiyu} />

                            <img className={this.props.jihao.includes(14)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                            <img className={this.props.jihao.includes(29)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                            <img className={this.props.jihao.includes(50)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                            <img className={this.props.jihao.includes(77)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />

                        </div>
                        <div className={styles["div-center"]}>
                            <img className={this.props.jihao.includes(61)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(37)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(19)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(7)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(1)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />

                            <img className={styles["img-bee"]} src={defaultImg}/>

                            <img className={this.props.jihao.includes(4)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                            <img className={this.props.jihao.includes(13)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                            <img className={this.props.jihao.includes(28)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                            <img className={this.props.jihao.includes(49)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                            <img className={this.props.jihao.includes(76)? styles["img-badge"] :styles["img-badge2"]} src={badgePinde} />
                        </div>
                        <div className={styles["div-center-right1"]}>
                            <img className={this.props.jihao.includes(62)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(38)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(20)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(8)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(2)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />

                            <img className={this.props.jihao.includes(3)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                            <img className={this.props.jihao.includes(12)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                            <img className={this.props.jihao.includes(27)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                            <img className={this.props.jihao.includes(48)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                            <img className={this.props.jihao.includes(75)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                        </div>
                        <div className={styles["div-center-right2"]}>
                            <img className={this.props.jihao.includes(63)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(39)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(21)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(9)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(10)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />

                            <img className={this.props.jihao.includes(11)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                            <img className={this.props.jihao.includes(26)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                            <img className={this.props.jihao.includes(47)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                            <img className={this.props.jihao.includes(74)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />

                        </div>
                        <div className={styles["div-center-right3"]}>
                            <img className={this.props.jihao.includes(64)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(40)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(22)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(23)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(24)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(25)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                            <img className={this.props.jihao.includes(46)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                            <img className={this.props.jihao.includes(73)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />

                        </div>
                        <div className={styles["div-center-right4"]}>
                            <img className={this.props.jihao.includes(65)? styles["img-badge"] :styles["img-badge2"]} src={badgeLaodong} />
                            <img className={this.props.jihao.includes(41)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(42)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(43)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(44)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(45)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />
                            <img className={this.props.jihao.includes(72)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />

                        </div>
                        <div className={styles["div-center-right5"]}>
                            <img className={this.props.jihao.includes(66)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(67)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(68)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(69)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(70)? styles["img-badge"] :styles["img-badge2"]} src={badgeYishu} />
                            <img className={this.props.jihao.includes(71)? styles["img-badge"] :styles["img-badge2"]} src={badgeShuxue} />

                        </div>

                    </div>


                </div>


            </div>
        );
    }
}


export default BadgeSmall;
